module.exports = __webpack_public_path__ + "img/treeplant3_7-8-2021.f7f68660.jpg";